import { Provider } from 'react-redux';

export default function withStore(Component, store) {
  return (
    <Provider store={store}>
      <Component />
    </Provider>
  );
}
